import { ROLE_TYPE_CAREGIVER } from "../../../constants/RegisterConstants";
import { RouterAddress } from "../../../constants/RouterAddress";
import ResidentEntryLogPageContent from "../../resident/components/ResidentEntryLogPageContent";

type CaregiverIncidentReportPageProps = {
  allowSharedStaffAccess?: boolean;
  dashboardPathOverride?: string;
  sharedMode?: boolean;
};

export const CaregiverIncidentReportPageContent = ({
  allowSharedStaffAccess = false,
  dashboardPathOverride = RouterAddress.CAREGIVER_HOME,
  sharedMode = false,
}: CaregiverIncidentReportPageProps) => (
  <ResidentEntryLogPageContent
    expectedRole={ROLE_TYPE_CAREGIVER}
    allowSharedStaffAccess={allowSharedStaffAccess}
    sharedMode={sharedMode}
    dashboardPathOverride={dashboardPathOverride}
    entryType="incident"
    pageTitle="Incident Reports"
    pageSubtitle="Write down serious or unusual events clearly so the provider can review them."
    sectionTitle="Incident Reports"
    sectionDescription=""
    defaultComposerVisible={true}
    showComposerToggleButton={true}
    compactActionBar={true}
    compactDraftsAction={true}
    compactComposerLabel="New Entry"
    allowedCompactSections={sharedMode ? ["composer", "monthly", "recent", "drafts"] : ["composer", "drafts"]}
    enableMonthlyReport={sharedMode}
    monthlyReportTitle="Generate Reports"
    monthlyReportDescription="Review the month's incident reports and export a clean summary for your records."
    loadMonthlyReport={(backendAPIStore, residentId, options) => backendAPIStore.getResidentIncidentReportMonthlyDataset(residentId, options)}
    generateMonthlyReportDocument={(backendAPIStore, residentId, requestBody) => backendAPIStore.generateResidentIncidentReportDocument(residentId, requestBody)}
    hideEntriesSection={!sharedMode}
    loadEntriesPage={(backendAPIStore, residentId, options) =>
      backendAPIStore.getCaregiverResidentIncidentReportsPage(residentId, options)}
    createEntry={(backendAPIStore, residentId, payload) =>
      backendAPIStore.createCaregiverResidentIncidentReport(residentId, payload)}
    updateEntry={(backendAPIStore, residentId, payload) =>
      backendAPIStore.updateCaregiverResidentIncidentReport(residentId, payload)}
    deleteDraft={(backendAPIStore, residentId, entryLogId) =>
      backendAPIStore.deleteCaregiverResidentIncidentReport(residentId, entryLogId)}
    canEditEntry={(entry, currentUserId) =>
      sharedMode || (String(entry?.recordedByUserId || "").trim() === String(currentUserId || "").trim()
      && String(entry?.status || "").trim().toLowerCase() === "draft")}
  />
);

const CaregiverIncidentReportPage = () => (
  <CaregiverIncidentReportPageContent />
);

export default CaregiverIncidentReportPage;
